import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FlipVerticalIcon = function FlipVerticalIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FlipVerticalIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 1.275c.4 0 .725.325.725.725v12a.725.725 0 0 1-1.45 0V2c0-.4.325-.725.725-.725M9.942 4.682v6.651c0 .4.324.725.725.725H14a.725.725 0 0 0 .649-1.049l-3.327-6.652a.7.7 0 0 0-.274-.307.726.726 0 0 0-1.106.632m1.45 3.056 1.435 2.87h-1.435zM4.678 4.357l-3.326 6.652A.725.725 0 0 0 2 12.06h3.333c.4 0 .725-.325.725-.726v-6.65a.724.724 0 0 0-.815-.736.73.73 0 0 0-.565.41m-.07 3.38-1.435 2.871h1.435z",
      clipRule: "evenodd"
    })
  }));
};

export { FlipVerticalIcon };
